{
  "documentTitle": "Join your team on Salt",
  "heading": "Join your team",
  "instructions": "You've been invited to serve on a volunteer team. Get the Salt app to accept your invitation.",
  "steps": {
    "download": "Download the Salt app",
    "reopen": "Tap the invite link in your email again",
    "signIn": "Sign in with your email to join the team"
  }
}
